import React, { useCallback, useContext, useEffect, useState } from 'react';
import { message } from 'antd';

import { usePopup } from '../../hooks/popup';
import { apiPHP } from '../../services/api';
import { GameContext } from './context/GameContext';

/* Components */
import Board from './components/Board';
import { Clues } from './components/Clues';
import Keyboard from './components/Keyboard';
import { GameWrapper } from './components/Board/styles';

/* Interfaces & API */
import { handleFinishGame } from './utils/handleFinishGame';

import { Container, Content, GameContent } from './styles';
import { useTimerContext } from '../../hooks/TimerContext';
import { GameHeader } from '../../components/GameHeader';
import { Sidebar } from '../../components/Sidebar';
import { IoTriangleSharp } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
interface GameDetail {
  titulo: string;
  estilos_de_passatempos_id: number;
  texto: string;
}

interface BaseProps {
  direct: boolean;
  size: number;
  sizeHeight: number;
  gameDetail: GameDetail;
}

const BaseCrossWords: React.FC<BaseProps> = ({
  direct,
  gameDetail,
  size,
  sizeHeight,
}) => {
  // let id = 27;
  let id = 0;
  const params = useParams();

  id = Number(params.id);

  const {
    state: { GameState },
    state,
    dispatch,
  } = useContext(GameContext);

  const { handleStopTimer, resetTimer } = useTimerContext();

  const [letter, setLetter] = useState('');
  const [showed, setShowed] = useState(false);
  const [isHintUsed, setIsHintUsed] = useState(false);
  const [points, setPoints] = useState(0);

  const { mountPopup } = usePopup();

  let maxScore = 0;

  state.GameTemplate.matrix.forEach((house) => {
    house.forEach((block) => {
      if (
        !(block.palavra_horizontal === -1) ||
        !(block.palavra_vertical === -1)
      ) {
        maxScore += 1;
      }
    });
  });

  useEffect(() => {
    //For avoid double letter
    if (letter === '') return;
    dispatch({
      type: 'INSERT',
      payload: { value: letter },
    });
    setTimeout(() => {
      setLetter('');
    }, 200);
  }, [dispatch, letter]);

  const handleKeyPress = useCallback((event) => {
    console.log(event);
    if (
      event.key.toUpperCase() === 'BACKSPACE' ||
      event.key.toUpperCase() === 'DELETE'
    ) {
      return;
    }
    if (/[a-zA-Z]/.test(event.key)) {
      const keyPressed = event.key;
      //Avoid double letter
      setLetter(keyPressed);
    }
  }, []);

  const handleVirtualKeyPress = useCallback(
    (key: string) => {
      if (key === '⌫') {
        dispatch({
          type: 'HANDLE_BACKSPACE',
        });
      } else {
        const keyPressed = key;
        setLetter(keyPressed);
      }
    },
    [dispatch]
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (
        event.key.toUpperCase() === 'BACKSPACE' ||
        event.key.toUpperCase() === 'DELETE'
      ) {
        dispatch({
          type: 'HANDLE_BACKSPACE',
        });
      }
    },
    [dispatch]
  );

  // Função de salvar o jogo.
  const saveGame = useCallback(async () => {
    message.loading({ content: 'Salvando jogo...', key: 'saveGame' });
    var progress = {
      tempo: 0,
      // tempo:  time,
      pontuacao: GameState.savedGame.cache.pontuacao,
      matrix: GameState.savedGame.cache.matrix,
    };

    await apiPHP.post(`/passatempos/${id}/progresso`, progress).catch((err) => {
      throw err;
    });
  }, [
    GameState.savedGame.cache.matrix,
    GameState.savedGame.cache.pontuacao,
    id,
  ]);

  useEffect(() => {
    window.addEventListener('keypress', handleKeyPress);
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('visibilitychange', saveGame);
    //console.log(GameState.time)
    if (GameState.time) {
      // resetTimer(GameState.time);
    }
    //setInterval(saveGame, 1800000);

    // startTimer();
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keypress', handleKeyPress);
      window.removeEventListener('visibilitychange', saveGame);
    };
  }, [GameState.time, handleKeyDown, handleKeyPress, saveGame]);

  // Função de voltar para a página anterior.
  const handleBack = () => {
    saveGame();
    // resetTimer(0);
    dispatch({
      type: 'RESET',
    });
    // router.back();
  };

  // Função para finalizar o jogo e checar os acertos.
  const handleHits = useCallback(() => {
    mountPopup({
      title: 'Deseja realmente Finalizar o jogo?',
      message: 'Boa sorte!',
      type: 'alegre',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: () => {
            dispatch({
              type: 'CHECK_GAME',
            });
            handleFinishGame(state, id, mountPopup, isHintUsed);
            handleStopTimer();
            !isHintUsed && setPoints(state.GameState.score);
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  }, [mountPopup, dispatch, isHintUsed, state, id, handleStopTimer]);

  // Função para mostrar as respostas.
  // all: para todas e one: para uma
  const handleShowAnswers = useCallback(() => {
    mountPopup({
      title: 'Deseja revelar as respostas?',
      message: 'Se utilizar a ajuda, sua pontuação será zerada!',
      type: 'atencao',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: () => {
            dispatch({
              type: 'REVEAL_ALL_GAME',
            });
            handleFinishGame(state, id, mountPopup, true);
            handleStopTimer();
            setIsHintUsed(true);
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  }, [mountPopup, dispatch, state, id, handleStopTimer]);

  // Função para limpar o jogo.
  const cleanGame = useCallback(() => {
    mountPopup({
      title: 'Deseja realmente limpar o jogo?',
      message: 'Se sim, a pontuação será zerada e o jogo recomeçará do início!',
      type: 'atencao',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: () => {
            dispatch({
              type: 'CLEAR_GAME',
            });
            resetTimer();
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  }, [dispatch, mountPopup, resetTimer]);

  useEffect(() => {
    if (GameState.completed && !showed) {
      mountPopup({
        title: 'A Recreativa!',
        message:
          'Você concluiu este passatempo, parabéns!  Para continuar, clique no menu superior direito, os 3 pontinhos, e verifique seus acertos. 😁',
        type: 'alegre',
        buttons: [
          {
            buttonText: 'ok',
            isPurple: true,
          },
        ],
      });
      setShowed(true);
    }
  }, [GameState.completed, mountPopup, showed]);

  const handleOnPressRevealLetter = useCallback(() => {
    mountPopup({
      title: 'Deseja revelar a letra?',
      message: 'Se utilizar a ajuda, sua pontuação será zerada!',
      type: 'atencao',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: () => {
            dispatch({
              type: 'REVEAL_LETTER',
            });
            handleFinishGame(state, id, mountPopup, true);
            setIsHintUsed(true);
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  }, [mountPopup, dispatch, state, id]);

  const handleOnPressRevealWord = useCallback(() => {
    mountPopup({
      title: 'Deseja revelar a palavra?',
      message: 'Se utilizar a ajuda, sua pontuação será zerada!',
      type: 'atencao',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: () => {
            dispatch({
              type: 'REVEAL_WORD',
            });
            handleFinishGame(state, id, mountPopup, true);
            setIsHintUsed(true);
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  }, [mountPopup, dispatch, state, id]);

  const handleOnPressReset = useCallback(() => {
    mountPopup({
      title: 'Deseja realmente reiniciar o jogo?',
      message: 'Se sim, a pontuação será zerada e o jogo recomeçará do início!',
      type: 'atencao',
      buttons: [
        {
          buttonText: 'sim',
          buttonFunction: () => {
            dispatch({
              type: 'RESET_GAME',
            });
            resetTimer();
          },
        },
        {
          buttonText: 'não',
          isPurple: true,
        },
      ],
    });
  }, [dispatch, mountPopup, resetTimer]);

  return (
    <Container>
      <GameHeader
        type="CRUZADAS"
        menuItems={[
          {
            buttonFunctions: handleHits,
            buttonText: 'Verificar Acertos',
          },
          {
            buttonFunctions: handleShowAnswers,
            buttonText: 'Revelar Resposta',
          },
          {
            buttonFunctions: handleOnPressRevealWord,
            buttonText: 'Revelar Palavra',
          },
          {
            buttonFunctions: handleOnPressRevealLetter,
            buttonText: 'Revelar Letra',
          },
          {
            buttonFunctions: handleOnPressReset,
            buttonText: 'Recomeçar Jogo',
          },
          {
            buttonFunctions: cleanGame,
            buttonText: 'Limpar jogo',
          },
        ]}
        maxScore={maxScore}
        currentScore={points}
      />

      <Content>
        <GameContent>
          <div>
            <GameWrapper>
              <Board
                gameID={id}
                size={size}
                sizeHeight={sizeHeight}
                text={gameDetail.texto}
                title={gameDetail.titulo}
                direct={direct}
              />
            </GameWrapper>
            <Sidebar
              type="CRUZADAS"
              menuItems={[
                {
                  buttonFunctions: handleHits,
                  buttonText: 'Verificar acertos',
                },
                {
                  buttonFunctions: handleShowAnswers,
                  buttonText: 'Revelar resposta',
                },
                {
                  buttonFunctions: handleOnPressRevealWord,
                  buttonText: 'Revelar palavra',
                },
                {
                  buttonFunctions: handleOnPressRevealLetter,
                  buttonText: 'Revelar letra',
                },
                {
                  buttonFunctions: handleOnPressReset,
                  buttonText: 'Recomeçar jogo',
                },
                {
                  buttonFunctions: cleanGame,
                  buttonText: 'Limpar jogo',
                },
              ]}
              maxScore={maxScore}
              currentScore={points}
            />
          </div>
          {!direct && <Clues />}
        </GameContent>

        <Keyboard handleKeyPress={handleVirtualKeyPress} />
        <p style={{ background: '#7f4788' }}>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Content>
    </Container>
  );
};

export default BaseCrossWords;
